export enum VerificationDocumentType {
    GOVERNMENT = 1,
    UTILITY_BILL = 2,
    PAN_CARD = 3,
  }